var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("404 - Page Not Found")]),_c('p',[_vm._v("The page you are looking for does not exist.")])])
}]

export { render, staticRenderFns }